import React from 'react'
import { Typography } from 'antd'
import { useRefinementFlow } from '../hooks/useRefinementFlow'

const { Text } = Typography

/**
 * Component that displays the batch index and size for a refinement item
 */
const BatchIndicator = ({ refinementItemId }) => {
    const { getBatchIndex, getBatchSize } = useRefinementFlow()
    
    const batchIndex = getBatchIndex(refinementItemId)
    const batchSize = getBatchSize(refinementItemId)

    // Don't render if we don't have valid batch information
    if (!batchIndex || !batchSize) {
        return null
    }

    return (
        <Text type="secondary" style={{ fontSize: '14px', fontWeight: 500 }}>
            {batchIndex} / {batchSize}
        </Text>
    )
}

export default BatchIndicator 